import { useAtom, useAtomValue } from 'jotai';
import { customThemeState } from '@/components/Atoms/customThemeAtom';
import { useQuery } from 'react-query';
import { configurationState } from '@/components/Atoms/ConfigurationAtom';
import { getJsonStorage } from '@/lib/fetch/json-storage/getJsonStorage';
import { userState } from '@/components/Atoms/UserAtom';
import { useEffect } from 'react';

export const useCustomTheme = () => {
    const [customTheme, setCustomTheme] = useAtom(customThemeState);
    const configuration = useAtomValue(configurationState);
    const user = useAtomValue(userState);

    const { data, isSuccess } = useQuery(
        ['jsonStorage'],
        () => getJsonStorage(configuration, user.securityToken),
        {
            enabled: !!user.id,
        }
    );

    useEffect(() => {
        if (isSuccess && data?.data?.json) {
            const json = data.data.json as any;
            const cssVariables = json?.cssVariables ?? json?.cssVars ?? '';
            const logo = json?.logo ?? '';
            setCustomTheme({ cssVariables, logo });
        }
    }, [data, isSuccess, setCustomTheme]);

    const getCustomTheme = () => {
        return customTheme;
    };
    return { getCustomTheme, setCustomTheme };
};
